import ReceiveQR from './ReceiveQR';

export default ReceiveQR;
